import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import Layout from "@/layout";
import Head from "next/head";
import logo from "@/assets/images/logo.svg";
import { useRef } from "react";
import { statTrack } from "@/utils/mtstat";
import Module from "./components/module";
import { mCardList, mCardList2 } from "@/constants/home";
import CardModule from "./components/cardModule";
import CustomModule from "./components/customModule";
import Scene from "./components/scene";
import Marquee from "./components/marquee";
import * as clipboard from "clipboard-polyfill";
import { message } from "antd";
import "antd/es/message/style/css";
import dynamic from "next/dynamic";
import { isWeiXin, isAndroid, isQQ } from "@/utils";
import { TITLE, HOME_DESCRIPTION, HOME_KEYWORDS, getPPTUrl } from "@/constants";

const WxMask = dynamic(() => import("./components/wxMask"), {
  ssr: false,
});

const Mobile = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [wxMaskVisible, setWxMaskVisible] = useState(false);
  const downloadLink = isAndroid()
    ? "https://releases-cicity.meitu.com/hosted/apk/d/d6p3e4z6cdipejygakqk5acmhf/官网/美图设计室_正式版.apk"
    : "https://apps.apple.com/cn/app/hai-bao-gong-chang/id875654777";

  useEffect(() => {
    statTrack("ai_create_show", {
      ppt_home_page: "landing_page",
    });
  }, []);

  useEffect(() => {
    // 监听video的播放暂停
    const video = videoRef.current;
    if (video) {
      video.addEventListener("play", () => {
        statTrack("tools_click_ppt_home", {
          click_type: "video",
        });
      });
    }
    return () => {
      if (video) {
        video.removeEventListener("play", () => {});
      }
    };
  }, []);

  const handleCopyLink = async () => {
    statTrack("tools_click_ppt_home", {
      click_type: "h5_copy_url",
    });
    clipboard.writeText(`https://ppt.designkit.cn/`).then(
      () => {
        message.success("复制成功");
      },
      () => {
        message.error("复制失败");
      }
    );
  };

  const handleDownload = async () => {
    const openApp = (await import("@meitu/open-app")).default;
    statTrack("tools_click_ppt_home", {
      click_type: "h5_download_app",
    });
    if (isWeiXin() || isQQ()) {
      setWxMaskVisible(true);
    } else {
      openApp("xdesign", {
        scheme: `mthbp://webview?show_shareButton=true&hideHeader=false&url=${encodeURIComponent(
          `${getPPTUrl()}/workspace`
        )}`,
        download: downloadLink,
      });
      console.log("下载APP");
    }
  };

  return (
    <Layout>
      <Head>
        <title>{TITLE}</title>
        <meta name="description" content={HOME_DESCRIPTION} />
        <meta name="keywords" content={HOME_KEYWORDS} />
      </Head>
      <div className={styles.mobile}>
        <div className={styles.header}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={logo.src} alt="logo" width={134} height={18} />
        </div>
        <div className={styles.title}>
          下载APP或打开电脑端输入
          <br />
          一句话生成<span className={styles.tag}>LivePPT</span>
        </div>
        <div className={styles.content}>
          <div>
            <div className={styles.videoTitle}>AI生成高质量PPT</div>
            <div className={styles.videoWrap}>
              <video
                className={styles.video}
                ref={videoRef}
                src="https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/video-new3.mp4"
                autoPlay
                muted
                loop
                playsInline
                controls
                x5-playsinline="true"
                webkit-playsinline="true"
                x5-video-orientation="portraint"
              />
            </div>
          </div>
          {/* 动态模式全新推出，让汇报更生动 */}
          <Module />

          {/* 多种方式生成PPT，更灵活 */}
          <CardModule cardList={mCardList} title="多种方式生成PPT，更灵活" />

          {/* 内容/模板可自定义，更符合心意 */}
          <CustomModule />

          {/* 文字/图片可AI编辑，智能设计更高效 */}
          <CardModule
            cardList={mCardList2}
            title="文字/图片可AI编辑，智能设计更高效"
          />

          {/* 覆盖多场景 满足多人群PPT需求 */}
          <Scene />
        </div>

        {/* 提供风格多样的高级感PPT模板 */}
        <Marquee />
      </div>
      <div className={styles.footer}>
        <button className={styles.copyLink} onClick={handleCopyLink}>
          复制链接
        </button>
        <button className={styles.download} onClick={handleDownload}>
          下载APP
        </button>
      </div>
      <WxMask show={wxMaskVisible} onClose={() => setWxMaskVisible(false)} />
    </Layout>
  );
};

export default Mobile;
